export interface AlainSFConfig {
  /**
   * æ¯å¦å¿½ç¥æäºæ°æ®ç±»åæ ¡éª `ERRORSDEFAULT`ï¼é»è®¤ï¼`[ 'type', 'enum' ]`
   *
   * - `type` éå® Schema ä¸­ `type` ç±»å
   * - `enum` éå®åºå½æ¯é¢è®¾å®çæä¸¾å¼ä¹ä¸
   */
  ingoreKeywords?: string[];
  /**
   * [ajv](http://epoberezkin.github.io/ajv/#options) åæ°
   */
  ajv?: any;
  /**
   * æ¯å¦å®æ¶æ ¡éªï¼é»è®¤ï¼`true`
   * - `true` æ¯ä¸æ¬¡é½æ ¡éª
   * - `false` æäº¤æ¶æ ¡éª
   */
  liveValidate?: boolean;
  /**
   * æå®è¡¨å `autocomplete` å¼ï¼é»è®¤ï¼`on`
   */
  autocomplete?: 'on' | 'off' | null;
  /**
   * æ¯å¦ç«å³åç°éè¯¯è§è§ï¼é»è®¤ï¼`false`
   */
  firstVisual?: boolean;
  /**
   * æ¯å¦åªå±ç¤ºéè¯¯è§è§ä¸æ¾ç¤ºéè¯¯ææ¬ï¼é»è®¤ï¼`false`
   */
  onlyVisual?: boolean;
  /**
   * èªå®ä¹éç¨éè¯¯ä¿¡æ¯ï¼é»è®¤ï¼`{}`
   */
  errors?: { [key: string]: string };
  /**
   * é»è®¤å¨å±å¸å±ï¼ç±»åä¸ºï¼`SFUISchemaItem`ï¼ä½¿ç¨æ¶å ä¸å¯æºè½æç¤ºï¼ä¾å¦ï¼
   *
   * ```ts
   * ui: {} as SFUISchemaItem
   * ```
   */
  ui?: any;
  /**
   * åç´ ç»ä»¶å¤§å°ï¼ç¨äº `nzSize` å¼
   */
  size?: 'default' | 'large' | 'small';
  /**
   * æé®é£æ ¼ï¼ç±»åä¸ºï¼`SFButton`ï¼ä½¿ç¨æ¶å ä¸å¯æºè½æç¤ºï¼ä¾å¦ï¼
   *
   * ```ts
   * button: {} as SFButton
   * ```
   */
  button?: any;
  /**
   * dateå°é¨ä»¶ï¼`type="string"` ä¸ä¸æå® `schema.format` å `ui.format` æ¶æ¥ææ ¼å¼ï¼é»è®¤ï¼`yyyy-MM-dd HH:mm:ss`
   */
  uiDateStringFormat?: string;
  /**
   * dateå°é¨ä»¶ï¼`type="number"` ä¸ä¸æå® `schema.format` å `ui.format` æ¶æ¥ææ ¼å¼ï¼é»è®¤ï¼`T` 13ä½ Unix Timestamp
   */
  uiDateNumberFormat?: string;
  /**
   * timeå°é¨ä»¶ï¼`type="string"` ä¸ä¸æå® `schema.format` å `ui.format` æ¶æ¥ææ ¼å¼ï¼é»è®¤ï¼`HH:mm:ss`
   */
  uiTimeStringFormat?: string;
  /**
   * timeå°é¨ä»¶ï¼`type="number"` ä¸ä¸æå® `schema.format` å `ui.format` æ¶æ¥ææ ¼å¼ï¼é»è®¤ï¼`T` 13ä½ Unix Timestampï¼æ¥æç»ä¸ä½¿ç¨ `1970-01-01`
   */
  uiTimeNumberFormat?: string;
  /**
   * æå® `format: 'email'` çé»è®¤Emailåç¼ï¼é»è®¤ï¼`['qq.com', '163.com', 'gmail.com', '126.com', 'aliyun.com']`
   */
  uiEmailSuffixes?: string[];
}
